module.exports = __webpack_public_path__ + "static/logos/surf-forecast__icon--white-9e51235963ebe044defb6cd237266996.svg";